<template>
  <div class="risk-based-quality">
    <div v-if="!loader">
      <b-row>
        <b-colxx xxs="12">
          <div class="separator mb-5"></div>
        </b-colxx>
      </b-row>

      <!-- Header dropdown filter -->
      <b-row>
        <b-colxx xxs="12" class="mb-4 pl-0">
          <header-drop-down-filter
            :leftHeaderText="leftHeaderTextValue"
            :sites="allSitesList"
            :countries="countryList"
            :callApiCompleted="callApiCompleted"
            :checkedSitesApply="sitesSelected == 'all' ? allSitesList : sitesSelected"
            :checkedCountriesApply="countrySelected == 'all' ? countryList : countrySelected"
            :exportBtn="true"
            :participantsBtn="true"
            @onApplyCountry="getDataFromRadioButton"
            @onApplySites="getDataFromCheckbox"
            @onApplyParticipants="getParticipantsDataFromCheckbox"
            @onFetchedParticipants="fetchedParticipants"
            @onApplyFpi="filter"
            :dataPicker="dataPicker"
            @onApplyRangeMonth="getRangeMonth"
            v-if="studyData"
            :specificSiteId="specificSiteId"
            :zoomGraphValue="zoomGraphValue"
            :toggleFeatures="toggleFeatures"
            :studyData="studyData"
          ></header-drop-down-filter>
        </b-colxx>
      </b-row>
      <!-- End header dropdown filter -->

      <!-- Only show when zoomGraph -->
      <div v-if="zoomGraphValue" @click="zoomGraphValue = ''" class="mb-10 color_4c8ce4 expand-back">
        <i class="fa fa-caret-left" aria-hidden="true"></i>
        Back
      </div>
      <!-- End show when zoomGraph -->

      <b-row class="" v-show="zoomGraphValue === '' || zoomGraphValue === 'study-participant-status-maps' || zoomGraphValue === 'percentage-participant'">
        <!-- Maps Chart -->
        <b-colxx v-if="isMapsApiAvailable" :class="zoomGraphValue === 'study-participant-status-maps' ? 'col-xl-12 study-participant-status-maps-zoom' : specificSiteId && specificSiteId.length === 0 ? 'col-sm-12' : 'col-sm-6'" v-show="zoomGraphValue === '' || zoomGraphValue === 'study-participant-status-maps'" class="pl-0 pb-10" style="transition-duration: 0.2s">
          <StudyParticipantStatusMaps
            titleChart="Study Participant Status"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'study-participant-status-maps'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            containerId="blank"
            :rawData="rawParticipantStatus"
            :titleDate="toDate || todaysDate"
            :specificSiteId="specificSiteId"
            :dataLoaded="dataLoaded.rawParticipantStatus"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
          />
        </b-colxx>
        <!-- End Maps Chart -->

        <!-- Percentage participant status chart -->
        <b-colxx :class="zoomGraphValue === 'percentage-participant' ? 'col-sm-12 percentage-participant-zoom' : !isMapsApiAvailable && (!specificSiteId || specificSiteId.length === 0) ? 'col-sm-12' : 'col-sm-6'" v-show="zoomGraphValue === '' || zoomGraphValue === 'percentage-participant'" class="pl-0 pb-10" style="transition-duration: 0.2s">
          <PercentageParticipantByStatus
            containerId="blank"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'percentage-participant'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :fromDate="fromDate"
            :toDate="toDate"
            :studyID="studyId"
            titleChart="Percentage of Participants by Status as of"
            :titleDate="toDate || todaysDate"
            :filterTriggered="filterTriggered"
            :rawData="rawParticipantStatus"
            :specificSiteId="specificSiteId"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :dataLoaded="dataLoaded.rawParticipantStatus"
          />
        </b-colxx>
        <!-- End of percentage participant status chart -->

        <!-- Top 5 site with most active participant list -->
        <b-colxx v-if="specificSiteId && specificSiteId.length === 0" :class="zoomGraphValue === 'mostactive-participant' ? 'col-sm-12 mostactive-participant-zoom' : 'col-sm-6'" v-show="zoomGraphValue === '' || zoomGraphValue === 'mostactive-participant'" class="pl-0 pb-10" style="transition-duration: 0.2s">
          <TopFiveMostActiveParticipant
            containerId="blank"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'mostactive-participant'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :fromDate="fromDate"
            :toDate="toDate"
            titleChart="Top 5 Sites with Most Active Participants"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :titleDate="toDate || todaysDate"
            :filterTriggered="filterTriggered"
            :rawData="rawParticipantStatus"
            :dataLoaded="dataLoaded.rawParticipantStatus"
          />
        </b-colxx>
        <!-- End of top 5 site with most active participant list -->
      </b-row>

      <b-row v-show="zoomGraphValue === '' || zoomGraphValue === 'site-active-fpfv'">
        <!-- Site Activation to First Participant First Visit  -->
        <b-colxx :class="zoomGraphValue === 'site-active-fpfv' ? 'col-sm-12 site-active-fpfv-zoom' : 'col-sm-6'" class="pl-0 pb-10" style="transition-duration: 0.2s" v-show="zoomGraphValue === '' || zoomGraphValue === 'site-active-fpfv'" v-if="specificSiteId && specificSiteId.length === 0">
          <!-- Timeline chart -->
          <apex-bar-chart-card :vis="fpiDataForViz" containerId="site-active-fpfv" title="Site Activation to First Participant First Visit" :zoomGraphValue="zoomGraphValue" :specificSiteId="specificSiteId" v-on:zoomEnabled="zoomGraphValue = 'site-active-fpfv'" v-on:zoomDisabled="zoomGraphValue = ''" :dataLoaded="dataLoaded.fpiDataForViz"></apex-bar-chart-card>
        </b-colxx>
        <!-- End of Site Activation to First Participant First Visit  -->
        <b-colxx class="col-xl-6 col-lg-6 col-md-6 pl-0 pb-0 pr-0" v-if="specificSiteId && specificSiteId.length !== 0">
          <b-row class="pb-25">
            <b-colxx xl="6" lg="12" md="12" class="pl-0 pb-10">
              <b-card class="custom-card white-bg" style="height:135px">
                <b-card-header>
                  <div class="card-text-strong" title="Site Activation to First Participant First Visit">
                    Site Activation to First Participant First Visit
                  </div>
                </b-card-header>
                <div class="data-card-center height-90">
                  <div class="d-flex align-items-end justify-content-center">
                    <div class="number-text">
                      {{ getFirstInParticipantNumDays() }}
                    </div>
                    <div class="small-card-text pb-8 pl-2">days</div>
                  </div>
                </div>
              </b-card>
            </b-colxx>
            <b-colxx xl="6" lg="12" md="12" class="pl-0 pb-10">
              <!-- Fastest FPI -->
              <b-card class="custom-card white-bg" style="height:135px">
                <b-card-header>
                  <div class="card-text-strong" title="Fastest Sites to First-Participant-In">
                    First Participant In
                  </div>
                </b-card-header>
                <div class="align-start pb-6 pt-6 data-cards" v-if="getFirstInParticipantID()">
                  <div class="card-text-subtitle">
                    <span class="small-card-text">Participant ID</span>
                    <span class="add-tooltip">{{ getFirstInParticipantID() }}</span>
                    <div class="custom-tooltip hidden-text-custom">
                      <div>{{ getFirstInParticipantID() }}</div>
                    </div>
                  </div>
                  <div class="card-text-subtitle">
                    <span class="small-card-text">THREAD ID</span>
                    <span class="add-tooltip">{{ getThreadID() }}</span>
                    <div class="custom-tooltip hidden-text-custom">
                      <div>{{ getThreadID() }}</div>
                    </div>
                  </div>
                  <div class="card-text-subtitle">
                    <span class="small-card-text">Active Date</span>
                    <span>{{ fastestFpiDateBegin }}</span>
                  </div>
                  <div class="card-text-subtitle">
                    <span class="small-card-text">FPI Date</span>
                    <span>{{ fastestFpiDateEnd }}</span>
                  </div>
                </div>
                <div v-else class="align-center">
                  <div class="card-text-title no-data" v-if="dataLoaded && dataLoaded.queriesRaw">
                    No Data In
                  </div>
                </div>
              </b-card>
            </b-colxx>
          </b-row>
          <b-row>
            <b-colxx xl="6" lg="12" md="12" class="pl-0 pb-10">
              <b-card class="custom-card white-bg">
                <b-card-header>
                  <div class="card-text-strong">Percentage of Queries Open</div>
                </b-card-header>
                <div class="data-card-center height-100">
                  <div v-if="queriesSeries && queriesSeries.open && queriesSeries.open !== 'NaN'" class="number-text">{{ queriesSeries.open }}%</div>
                  <div v-else class="align-center">
                    <div class="card-text-title no-data" v-if="dataLoaded && dataLoaded.queriesRaw">
                      No Data In
                    </div>
                    <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
                  </div>
                </div>
              </b-card>
            </b-colxx>
            <b-colxx xl="6" lg="12" md="12" class="pl-0 pb-10">
              <b-card class="custom-card white-bg">
                <b-card-header>
                  <div class="card-text-strong">
                    Percentage of Queries Responded
                  </div>
                </b-card-header>
                <div class="data-card-center height-100">
                  <div v-if="queriesSeries && queriesSeries.response && queriesSeries.response !== 'NaN'" class="number-text">{{ queriesSeries.response }}%</div>
                  <div v-else class="align-center">
                    <div class="card-text-title no-data" v-if="dataLoaded && dataLoaded.queriesRaw">
                      No Data In
                    </div>
                    <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
                  </div>
                </div>
              </b-card>
            </b-colxx>
          </b-row>
        </b-colxx>
        <!-- End of top 5 stats fpi -->

        <!-- Site Activation to First Participant First Visit  -->
        <b-colxx v-show="zoomGraphValue === ''" xl="6" lg="12" md="12" class="pl-0 pb-10">
          <Top5Queries :filterTriggered="filterTriggered" downloadId="top-five-queries-p2-id" titleChart="Top 5 Queries" :queriesRaw="queriesRaw" :dataLoaded="dataLoaded.queriesRaw" :specificSiteId="specificSiteId" :countrySelected="this.countrySelected === 'all' ? this.countryList : this.countrySelected" :sitesSelected="this.sitesSelected[0] === 'all' ? this.allSitesList : this.sitesSelected">
          </Top5Queries>
        </b-colxx>
        <!-- End of Site Activation to First Participant First Visit  -->
      </b-row>

      <b-row v-show="zoomGraphValue === '' || zoomGraphValue === 'rbac-overall-query-status' || zoomGraphValue === 'rbac-overall-missing-data'" v-if="specificSiteId && specificSiteId.length !== 0" class="">
        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'rbac-overall-query-status'" class="pl-0 pb-10" :class="zoomGraphValue === 'rbac-overall-query-status' ? 'col-xl-12 col-lg-12 col-md-12 rbac-overall-query-status-zoom' : 'col-xl-6 col-lg-6 col-md-6'" style="transition-duration: 0.2s">
          <QueryStatusBar
            :filterTriggered="filterTriggered"
            titleChart="Query Status"
            class="rbac-overall-query-status"
            downloadId="rbac-overall-query-status"
            :tabListOverallQueryStatus="tabListOverallQueryStatus"
            xAxisName="Days"
            yAxisName="Total per Status"
            :queriesRaw="queriesRaw"
            :countrySelected="this.countrySelected === 'all' ? this.countryList : this.countrySelected"
            :sitesSelected="this.sitesSelected[0] === 'all' ? this.allSitesList : this.sitesSelected"
            :zoomGraphValue="zoomGraphValue"
            :dataLoaded="dataLoaded.queriesRaw"
            v-on:zoomEnabled="zoomGraphValue = 'rbac-overall-query-status'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
          >
          </QueryStatusBar>
        </b-colxx>

        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'rbac-overall-missing-data'" v-if="complianceWidgets" :class="zoomGraphValue === 'rbac-overall-missing-data' ? 'col-xl-12 rbac-overall-missing-data-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-10" style="transition-duration: 0.2s">
          <OverallMissingDataCard
            titleChart="Overall Missing Data"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'rbac-overall-missing-data'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :rawSeries="overallMissingRaw"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :dataLoaded="dataLoaded.overallMissingRaw"
          />
        </b-colxx>
      </b-row>

      <b-row v-show="zoomGraphValue === '' || zoomGraphValue === 'overall-query-status'" v-if="specificSiteId && specificSiteId.length === 0" class="">
        <!-- End of top 5 stats fpi -->
        <b-colxx v-show="zoomGraphValue === ''" xl="6" lg="6" md="12" class="pl-0 pb-0 pr-0">
          <b-row class="">
            <b-colxx xl="6" lg="12" md="12" class="pl-0 pb-29 pr-27">
              <b-card class="custom-card white-bg" style="height:135px">
                <b-card-header>
                  <div class="card-text-strong" title="Total Sites with FPI">
                    Total Sites with FPI
                  </div>
                </b-card-header>
                <div class="data-card-center height-90">
                  <div class="number-text">
                    {{ totalFpiSites }}
                  </div>
                </div>
              </b-card>
            </b-colxx>
            <b-colxx xl="6" lg="12" md="12" class="pl-0 pb-29">
              <!-- Fastest FPI -->
              <b-card class="custom-card white-bg" style="height:135px">
                <b-card-header>
                  <div class="card-text-strong" title="Fastest Sites to First-Participant-In">
                    Site with First Participant In
                  </div>
                </b-card-header>
                <div class="align-start pb-6 pt-6 data-cards" v-if="fastestFpiSiteCountry !== null && fastestFpiSiteCountry !== ''">
                  <div class="card-text-subtitle">
                    <span class="small-card-text">Site</span>
                    <span class="add-tooltip">{{ fastestFpiSiteCountry ? fastestFpiSiteCountry.site : "" }}</span>
                    <div class="custom-tooltip hidden-text-custom">
                      <div>
                        {{ fastestFpiSiteCountry ? fastestFpiSiteCountry.site : "" }}
                      </div>
                    </div>
                  </div>
                  <div class="card-text-subtitle">
                    <span class="small-card-text">Country</span>
                    <span class="add-tooltip">{{ fastestFpiSiteCountry ? fastestFpiSiteCountry.country : "" }}</span>
                    <div class="custom-tooltip hidden-text-custom">
                      <div>
                        {{ fastestFpiSiteCountry ? fastestFpiSiteCountry.country : "" }}
                      </div>
                    </div>
                  </div>
                  <div class="card-text-subtitle">
                    <span class="small-card-text">Active Date</span>
                    <span>{{ fastestFpiDateBegin }}</span>
                  </div>
                  <div class="card-text-subtitle">
                    <span class="small-card-text">FPI Date</span>
                    <span>{{ fastestFpiDateEnd }}</span>
                  </div>
                </div>
                <div v-else class="align-center">
                  <div class="card-text-title no-data" v-if="dataLoaded">
                    No Data In
                  </div>
                </div>
              </b-card>
            </b-colxx>
          </b-row>
          <b-row>
            <b-colxx xl="6" lg="12" md="12" class="pl-0 pb-0 pr-27">
              <b-card class="custom-card white-bg" style="height:135px">
                <b-card-header>
                  <div class="card-text-strong">Percentage of Queries Open</div>
                </b-card-header>
                <div class="data-card-center height-100">
                  <div v-if="queriesSeries && queriesSeries.open && queriesSeries.open !== 'NaN'" class="number-text">{{ queriesSeries.open }}%</div>
                  <div v-else class="align-center">
                    <div class="card-text-title no-data" v-if="dataLoaded && dataLoaded.queriesRaw">
                      No Data In
                    </div>
                    <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
                  </div>
                </div>
              </b-card>
            </b-colxx>
            <b-colxx xl="6" lg="12" md="12" class="pl-0 pb-26">
              <b-card class="custom-card white-bg" style="height:135px">
                <b-card-header>
                  <div class="card-text-strong">
                    Percentage of Queries Responded
                  </div>
                </b-card-header>
                <div class="data-card-center height-100">
                  <div v-if="queriesSeries && queriesSeries.response && queriesSeries.response !== 'NaN'" class="number-text">{{ queriesSeries.response }}%</div>
                  <div v-else class="align-center">
                    <div class="card-text-title no-data" v-if="dataLoaded && dataLoaded.queriesRaw">
                      No Data In
                    </div>
                    <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
                  </div>
                </div>
              </b-card>
            </b-colxx>
          </b-row>
        </b-colxx>
        <!-- End of top 5 stats fpi -->

        <!-- QUERY STATUS  -->
        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'overall-query-status'" :class="zoomGraphValue === 'overall-query-status' ? 'col-xl-12 overall-query-status-zoom' : 'col-xl-6'" xl="6" lg="6" md="12" class="pl-0 pb-10" style="transition-duration: 0.2s">
          <QueryStatusBar
            :filterTriggered="filterTriggered"
            titleChart="Query Status"
            class="overall-query-status"
            downloadId="overall-query-status"
            :tabListOverallQueryStatus="tabListOverallQueryStatus"
            xAxisName="Days"
            yAxisName="Total per Status"
            :queriesRaw="queriesRaw"
            :countrySelected="this.countrySelected === 'all' ? this.countryList : this.countrySelected"
            :sitesSelected="this.sitesSelected[0] === 'all' ? this.allSitesList : this.sitesSelected"
            :zoomGraphValue="zoomGraphValue"
            :dataLoaded="dataLoaded.queriesRaw"
            v-on:zoomEnabled="zoomGraphValue = 'overall-query-status'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
          >
          </QueryStatusBar>
        </b-colxx>
        <!-- End of QUERY STATUS & TOP 5 QUERIES CHART  -->
      </b-row>

      <!-- Time to Activity Status (Entry Completed/Approved/Verified/Signed Off)  -->
      <b-row v-show="zoomGraphValue === '' || zoomGraphValue === 'time-activities-status'">
        <!-- TODO YOUR LOGIC -->
        <b-colxx :class="zoomGraphValue === 'time-activities-status' ? 'time-activities-status-zoom' : ''" xl="12" lg="12" md="12" class="pl-0 pb-10" style="transition-duration: 0.2s">
          <TimeToActivitiesStatusCard
            :activitiesRaw="activitiesRaw"
            :countrySelected="this.countrySelected === 'all' ? this.countryList : this.countrySelected"
            :sitesSelected="this.sitesSelected[0] === 'all' ? this.allSitesList : this.sitesSelected"
            :tabListActCountSit="tabListActCountSit"
            containerId="blank"
            v-on:zoomEnabled="zoomGraphValue = 'time-activities-status'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :zoomGraphValue="zoomGraphValue"
            :specificSiteId="specificSiteId"
            titleChart="Time to Activity Status (Entry Completed/Approved/Verified/Signed Off)"
            downloadId="time-activities-status"
            :dataLoaded="dataLoaded.activitiesRaw"
            :filterTriggered="filterTriggered"
          >
          </TimeToActivitiesStatusCard>
        </b-colxx>
      </b-row>
      <!-- Time to Activity Status (Entry Completed/Approved/Verified/Signed Off)  -->

      <!-- Percentage of Activity Status (Entry Completed/Approved/Verified/Signed Off)  -->
      <b-row v-show="zoomGraphValue === '' || zoomGraphValue === 'percentage-activities'">
        <b-colxx :class="zoomGraphValue === 'percentage-activities' ? 'percentage-activities-zoom' : ''" xl="12" lg="12" md="12" class="pl-0 pb-10" style="transition-duration: 0.2s">
          <TimeActivitiesPercentage
            :activitiesRaw="activitiesRaw"
            :specificSiteId="specificSiteId"
            :countrySelected="this.countrySelected === 'all' ? this.countryList : this.countrySelected"
            :sitesSelected="this.sitesSelected[0] === 'all' ? this.allSitesList : this.sitesSelected"
            :tabListActCountSit="tabListActCountSit"
            v-on:zoomEnabled="zoomGraphValue = 'percentage-activities'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :zoomGraphValue="zoomGraphValue"
            titleChart="Percentage of Activity Status (Entry Completed/Approved/Verified/Signed Off)"
            downloadId="percentage-activities"
            :dataLoaded="dataLoaded.activitiesRaw"
            :filterTriggered="filterTriggered"
          >
          </TimeActivitiesPercentage>
        </b-colxx>
      </b-row>
      <!-- Percentage of Activity Status (Entry Completed/Approved/Verified/Signed Off)  -->

      <b-row class="">
        <!-- average time cards  -->
        <average-time-cards :valueSizeOnXL="'6'" :useDualRow="true" :zoomGraphValue="zoomGraphValue" :activitiesRaw="activitiesRaw" :filterTriggered="filterTriggered" :dataLoaded="dataLoaded.activitiesRaw" :sitesSelected="this.sitesSelected[0] === 'all' ? this.allSitesList : this.sitesSelected" :countrySelected="this.countrySelected === 'all' ? this.countryList : this.countrySelected">
        </average-time-cards>
        <!-- average time cards  -->

        <!-- FORM STATUS  -->
        <b-colxx :class="zoomGraphValue === 'form-status' ? 'col-xl-12 form-status-zoom' : 'col-xl-6'" v-show="zoomGraphValue === '' || zoomGraphValue === 'form-status'" xl="6" lg="6" md="12" class="pl-0 pb-14" style="transition-duration: 0.2s">
          <FormStatusCard
            :filterTriggered="filterTriggered"
            titleChart="Form Status"
            downloadId="form-status"
            class="form-status"
            xAxisName="Days"
            yAxisName="Total per Status"
            :countrySelected="this.countrySelected === 'all' ? this.countryList : this.countrySelected"
            :sitesSelected="this.sitesSelected[0] === 'all' ? this.allSitesList : this.sitesSelected"
            :formStatusRaw="formStatusRaw"
            :zoomGraphValue="zoomGraphValue"
            :dataLoaded="dataLoaded.formStatusRaw"
            v-on:zoomEnabled="zoomGraphValue = 'form-status'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
          ></FormStatusCard>
        </b-colxx>
        <!-- FORM STATUS  -->
      </b-row>

      <b-row class="">
        <!-- TOP 5 Longest time  -->
        <b-colxx xl="6" lg="12" md="12" class="pl-0 pb-10" v-show="zoomGraphValue === ''">
          <TopTimeActivity
            :filterTriggered="filterTriggered"
            titleChart="Top 5 Longest Time to Status"
            downloadId="topFivelongest-p2-id"
            :countrySelected="this.countrySelected === 'all' ? this.countryList : this.countrySelected"
            :sitesSelected="this.sitesSelected[0] === 'all' ? this.allSitesList : this.sitesSelected"
            :tabListTopTimeStatus="tabListTopTimeStatus"
            :activitiesRaw="activitiesRaw"
            :specificSiteId="specificSiteId"
            :dataLoaded="dataLoaded.activitiesRaw"
          >
          </TopTimeActivity>
        </b-colxx>
        <!-- TOP 5 Longest time  -->

        <!-- Overall Missing Data  -->
        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'overall-missing-data'" :class="zoomGraphValue === 'overall-missing-data' ? 'col-xl-12 overall-missing-data-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-10" style="transition-duration: 0.2s" v-if="complianceWidgets && specificSiteId && specificSiteId.length === 0">
          <OverallMissingDataCard
            titleChart="Overall Missing Data"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'overall-missing-data'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :rawSeries="overallMissingRaw"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :dataLoaded="dataLoaded.overallMissingRaw"
          />
        </b-colxx>
        <!-- Overall Missing Data  -->

        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'completion-data'" :class="zoomGraphValue === 'completion-data' ? 'col-xl-12 completion-data-zoom' : 'col-xl-6'" lg="6" md="6" class="pl-0 pb-10" style="transition-duration: 0.2s" v-if="specificSiteId && specificSiteId.length > 0">
          <!-- Create completion chart here -->
          <ActivitiesCompletionCard
            titleChart="Study Activity Completion by Day"
            :data="completionData"
            :participantData="completionDataByParticipant"
            :zoomGraphValue="zoomGraphValue"
            @zoomEnabled="zoomGraphValue = 'completion-data'"
            @zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :studyId="studyId"
            :fromDate="fromDate"
            :toDate="toDate"
            :siteListInParticipants="siteListInParticipants"
            :dataLoaded="dataLoaded.completionData"
            :participantsSelected="participantsSelected"
          />
        </b-colxx>
      </b-row>

      <b-row v-if="complianceWidgets" v-show="zoomGraphValue === '' || zoomGraphValue === 'compliance-data' || zoomGraphValue === 'completion-data'">
        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'compliance-data'" :class="zoomGraphValue === 'compliance-data' ? 'col-xl-12 compliance-data-zoom' : 'col-xl-6'" lg="6" md="6" class="pl-0 pb-10" style="transition-duration: 0.2s">
          <!-- Create compliance chart here -->
          <ActivitiesComplianceCard
            titleChart="Study Activity Compliance by Day"
            :data="complianceData"
            :participantData="complianceDataByParticipant"
            :zoomGraphValue="zoomGraphValue"
            @zoomEnabled="zoomGraphValue = 'compliance-data'"
            @zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :studyId="studyId"
            :fromDate="fromDate"
            :toDate="toDate"
            :siteListInParticipants="siteListInParticipants"
            :dataLoaded="dataLoaded.complianceData"
            :participantsSelected="participantsSelected"
          />
        </b-colxx>

        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'completion-data'" :class="zoomGraphValue === 'completion-data' ? 'col-xl-12 completion-data-zoom' : 'col-xl-6'" lg="6" md="6" class="pl-0 pb-10" style="transition-duration: 0.2s" v-if="specificSiteId && specificSiteId.length === 0">
          <!-- Create completion chart here -->
          <ActivitiesCompletionCard
            titleChart="Study Activity Completion by Day"
            :data="completionData"
            :participantData="completionDataByParticipant"
            :zoomGraphValue="zoomGraphValue"
            @zoomEnabled="zoomGraphValue = 'completion-data'"
            @zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :studyId="studyId"
            :fromDate="fromDate"
            :toDate="toDate"
            :siteListInParticipants="siteListInParticipants"
            :dataLoaded="dataLoaded.completionData"
            :participantsSelected="participantsSelected"
          />
        </b-colxx>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Loading from "vue-loading-overlay";
import HeaderDropDownFilter from "@/components/form-components/header-drop-down-filter";
import StudyParticipantStatusMaps from "@/components/containers/study-participant-status-maps";
import PercentageParticipantByStatus from "@/components/containers/percentage-participant-by-status-card";
import TopFiveMostActiveParticipant from "@/components/containers/top-five-most-active-participant";
import moment from "moment";
import _get from "lodash/get";
import { ACTIVITIES, COUNTRIES, PARTICIPANTS, SITES } from "@/constants/config";
import _isEmpty from "lodash/isEmpty";
import _has from "lodash/has";
import RecruitmentApexBarChartCard from "@/components/containers/recruitment-apex-bar-card";
import Top5Queries from "@/components/containers/top-5-queries";
import * as EnrollmentService from "@/services/visualization/recruitment";
import _ from "lodash";
import QueryStatusBar from "@/components/containers/query-status-bar";
import * as dManagement from "@/services/visualization/new-data-management";
import TimeToActivitiesStatusCard from "@/components/containers/time-to-activities-status-card";
import TimeActivitiesPercentage from "@/components/containers/time-activities-percentage";
import AverageTimeCards from "@/components/containers/average-time-cards";
import FormStatusCard from "@/components/containers/form-status.card";
import TopTimeActivity from "@/components/containers/top-time-activity";
import OverallMissingDataCard from "@/components/containers/overall-missing-data-card";
import ActivitiesComplianceCard from "@/components/containers/activities-compliance-card";
import * as d3 from "d3";
import ActivitiesCompletionCard from "@/components/containers/activities-completion-card";
import { mapGetters } from "vuex";
import * as utils from "@/services/visualization/utils";

const visible = "10";

const convertArrToString = arrObj => {
  let resultString = ``;
  if (arrObj && arrObj.length > 0) {
    arrObj.forEach(o => {
      resultString += `${o},`;
    });
    resultString = resultString.slice(0, -1);
  }
  return resultString;
};

Vue.use(Loading);
export default {
  name: "risk-based-quality",
  components: {
    AverageTimeCards,
    HeaderDropDownFilter,
    StudyParticipantStatusMaps,
    PercentageParticipantByStatus,
    TopFiveMostActiveParticipant,
    "apex-bar-chart-card": RecruitmentApexBarChartCard,
    Top5Queries,
    QueryStatusBar,
    TimeToActivitiesStatusCard,
    TimeActivitiesPercentage,
    FormStatusCard,
    TopTimeActivity,
    OverallMissingDataCard,
    ActivitiesComplianceCard,
    ActivitiesCompletionCard
  },
  props: {
    toggleFeatures: { type: Array, default: () => [] },
    complianceWidgets: { type: Boolean, default: false },
    studyData: { type: Object, default: null }
  },
  data() {
    return {
      studyId: null,
      filterTriggered: false,
      leftHeaderTextValue: "Risk Based Quality Metrics Dashboard",
      loader: null,
      dataPicker: [],
      allSitesList: [],
      countryList: [],
      participantList: [],
      siteListInParticipants: [],
      callApiCompleted: null,
      sitesSelected: ["all"],
      countrySelected: "all",
      participantsSelected: ["all"],
      todaysDate: "",
      monthSelected: [],
      firstFromDate: null,
      firstToDate: null,
      fromDate: null, //fromDate and toDate is a string value for date filter. Format would be YYYY-MM-DD
      toDate: null,
      specificSiteId: null, // for rbac feature
      tabList: [],
      TABS: index => {
        const defaultTab = {
          name: "default",
          visible
        };
        return this.tabList[index] || defaultTab;
      },
      tabListOverallQueryStatus: ["Day Ranges", "Activities"],
      tabListActCountSit: ["Activities", "Countries"],
      zoomGraphValue: "",
      circleMarkers: null,
      rawParticipantStatus: null,
      filteredRawDataSiteRecruitment: null,
      fpiDataForViz: null,
      queriesRaw: null,
      dataLoaded: {},
      isLoading: true,
      tmpCountries: [],
      tmpSites: [],
      totalFpiSites: 0,
      totalFirstDataSites: 0,
      fastestFpiDateBegin: "",
      fastestFpiDateEnd: "",
      fastestFirstDataDateBegin: "",
      fastestFirstDataDateEnd: "",
      fastestFpiSiteCountry: "",
      fastestFirstDataSiteCountry: "",
      queriesSeries: null,
      activitiesRaw: null,
      percentageOfActivityStatusSeries: { series: {}, csvData: {} },
      formStatusRaw: null,
      tabListTopTimeStatus: ["Entry Completed", "Approved", "Verified", "Signed Off"],
      overallMissingRaw: null,
      complianceData: [],
      complianceDataByParticipant: [],
      completionData: [],
      completionDataByParticipant: [],
      mapSiteCountry: {},
      tmpMapSiteCountry: {}
    };
  },

  methods: {
    getDateString(date) {
      const d = new Date(date);
      return date
        ? moment(d)
            .format("DD MMM YYYY")
            .toString()
            .toUpperCase()
        : "";
    },
    getThreadID() {
      if ((this.sitesSelected && this.sitesSelected.length === 0) || (this.countrySelected && this.countrySelected.length === 0)) {
        return " ";
      }
      return _get(this.siteRecruitmentRawData, [this.countryList[0], this.allSitesList[0], "firstParticipant"]);
    },
    getFirstInParticipantID() {
      const selectedParticipant = this.siteListInParticipants.filter(participant => {
        if (this.participantsSelected.length <= 0) {
          return false;
        }
        if (this.participantsSelected === "all" || this.participantsSelected[0] === "all") {
          return participant.participantId === this.getThreadID();
        } else {
          return this.participantsSelected.includes(participant.participantId) && participant.participantId === this.getThreadID();
        }
      });

      if (selectedParticipant.length) {
        return selectedParticipant[0].participantName ? selectedParticipant[0].participantName : " ";
      }

      return null;
    },
    getFirstInParticipantNumDays() {
      const fastestFpiDateBeginMoment = moment(this.fastestFpiDateBegin, "DD MMM YYYY");
      const fastestFpiDateEndMoment = moment(this.fastestFpiDateEnd, "DD MMM YYYY");

      return fastestFpiDateEndMoment.diff(fastestFpiDateBeginMoment, "days") || 0;
    },
    async prepareDatePicker() {
      const d = new Date();
      this.todaysDate = moment.utc(d).format("DD MMM YYYY");
      const studyData = this.studyData;
      const studyStartDate = studyData.studyStartDate;
      const datePicker = [];
      for (let m = moment(studyStartDate); m.diff(moment(), "months") <= 0; m.add(1, "months")) {
        datePicker.push(m.format("MMM YYYY"));
      }
      this.dataPicker = datePicker;
      const firstMonth = this.dataPicker[0];
      const lastMonth = this.dataPicker[this.dataPicker.length - 1];
      this.monthSelected = [firstMonth, lastMonth];
    },
    getDataFromRadioButton(payload) {
      this.filter("country", payload.isCheckAll ? "all" : payload.checked, payload.detailSite);
    },
    getSiteData(rawData, searchKeyword, filterKey = "name", responseKey = "userSiteId") {
      const siteData = _.find(rawData, allSitesWithDetails => {
        return allSitesWithDetails[filterKey] === searchKeyword;
      });
      return _.get(siteData, responseKey, "");
    },
    getDataFromCountry(payload) {
      this.filter("country", payload.isCheckAll ? "all" : payload.checked, payload.detailSite);
    },
    getDataFromSite(payload) {
      this.filter("site", payload.isCheckAll ? "all" : payload.checked, payload.detailSite);
    },
    getDataFromCheckbox(payload) {
      this.filter("site", payload.isCheckAll ? "all" : payload.checked, payload.detailSite);
    },
    getParticipantsDataFromCheckbox(payload) {
      this.filter("participant", payload.isCheckAll ? "all" : payload);
    },
    fetchedParticipants(payload) {
      this.siteListInParticipants = payload;
    },
    getRangeMonth(payload) {
      this.filter("date", payload, payload.detailSite);
    },
    setToEmptyData() {
      this.rawParticipantStatus = null;
      this.fpiDataForViz = null;
      this.totalFpiSites = 0;
      this.totalFpiSites = 0;
      this.fastestFpiSiteCountry = null;
      this.fastestFpiDateBegin = "";
      this.fastestFpiDateEnd = "";
      this.queriesRaw = null;
      this.queriesTimeRows = null;
      this.activitiesRaw = null;
      this.complianceData = [];
      this.completionData = [];
      this.complianceDataByParticipant = [];
      this.completionDataByParticipant = [];
      this.formStatusRaw = null;
      this.overallCollectionMetricRaw = null;
      this.overallCollectionMetricParticipantRaw = null;
      this.overallMissingRaw = null;
      this.filterTriggered = !this.filterTriggered;
    },
    async getParticipantStatusEndpoints() {
      this.isLoading = true;
      const response = {
        locations: null,
        boundaries: null
      };
      const params = {
        studyId: this.studyId
      };
      try {
        if (this.fromDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }
        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }
        if (this.specificSiteId && this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }
        const data = await this.$api.getParticipantStatusVisData(params);

        if (data.ok) {
          const result = data.body;

          if (!_isEmpty(result.data)) {
            if (_has(result, "data.locations")) {
              response.locations = _get(result, "data.locations", null);
            }
          }
        }

        this.isLoading = false;
      } catch (err) {}
      return response;
    },
    async getRecruitmentVisualizationRawData(recruitmentType = null) {
      let response = null;
      const params = {
        studyId: this.studyId
      };
      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }
      try {
        if (this.fromDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }
        if (recruitmentType) {
          params.recruitmentType = recruitmentType;
        }
        const data = await this.$api.getRecruitmentVisData(params);

        if (data.ok) {
          const result = data.body;

          if (result.data !== {}) {
            if ("locations" in result.data) {
              response = result.data.locations;
            }
          }
        }
      } catch (err) {}
      return response;
    },
    async getNewQueries() {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };

      try {
        if (this.fromDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }
        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }

        if (this.specificSiteId && this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }

        const data = await this.$api.getQueriesEndpoint(params);

        if (data.ok) {
          const result = data.body;

          if (result.data !== {}) {
            if ("activities" in result.data) {
              response = result.data.activities;
            }
          }
        }

        this.isLoading = false;
        // Only for development
        //   response = data.data.activities;
      } catch (err) {}
      return response;
    },
    async getNewActivities() {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };

      try {
        if (this.fromDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }

        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }

        if (this.specificSiteId && this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }

        const data = await this.$api.getActivitiesEndpoint(params);

        if (data.ok) {
          const result = data.body;

          if (result.data !== {}) {
            if ("activities" in result.data) {
              response = result.data.activities;
            }
          }
        }

        this.isLoading = false;
        // Only for development
        //   response = data.data.activities;
      } catch (err) {}
      return response;
    },
    async getNewFormStatus() {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };

      try {
        if (this.fromDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }

        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }

        if (this.specificSiteId && this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }

        const data = await this.$api.getFormStatusEndpoint(params);

        if (data.ok) {
          const result = data.body;

          if (result.data !== {}) {
            if ("locations" in result.data) {
              response = result.data.locations;
            }
          }
        }

        this.isLoading = false;
        // Only for development
        //   response = data.data.locations;
      } catch (err) {}
      return response;
    },
    async getOverallMissingData() {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };

        try {
          if (this.fromDate) {
            params.fromDate = this.fromDate;
            params.toDate = this.toDate;
          }

          if (this.participantsSelected && this.participantsSelected[0] !== "all") {
            params.participantsIds = convertArrToString(this.participantsSelected);
          }

          if (this.specificSiteId && this.specificSiteId.length > 0) {
            params.siteId = this.specificSiteId[0];
          }

          const data = await this.$api.getOverallColectionMissingEndpoint(params);

          if (data.ok) {
            const result = data.body;

            if (result.data !== {}) {
              if ("locations" in result.data) {
                response = result.data.locations;
              }
            }
          }

          this.isLoading = false;
        } catch (err) {}
        return response;
      }
    },
    async getComplianceData() {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };

        if (this.fromDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }
        try {
          if (this.participantsSelected && this.participantsSelected[0] !== "all") {
            params.participantsIds = convertArrToString(this.participantsSelected);
          }
          if (this.specificSiteId && this.specificSiteId.length > 0) {
            params.siteId = this.specificSiteId[0];
          }
          const data = await this.$api.getCompliance(params);
          if (data.ok) {
            try {
              response = d3.csvParse(data.body);
              response = d3
                .nest()
                .key(d => d.date)
                .sortKeys(d3.ascending)
                .key(d => d.countryName)
                .sortKeys(d3.ascending)
                .key(d => d.siteName)
                .sortKeys(d3.ascending)
                .entries(response);
            } catch (error) {
              return null;
            }
          }

          this.isLoading = false;
        } catch (err) {}
        return response;
      }
    },
    async getVisOverallEnrollementData() {
      this.isLoading = true;

      let response = null;
      const params = {
        studyId: this.studyId
      };
      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }
      try {
        if (this.fromDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }
        const responseData = await this.$api.getEnrollmentParticipantData(params);
        if (responseData.ok) {
          const { data } = responseData.body;
          // TODO: Dont forget to activated after api has been deployed!
          if (data !== {}) {
            response = data;
          } else {
            this.isLoading = false;
          }
        }

        this.isLoading = false;
      } catch (err) {}
      return response;
    },
    async getParticipantComplianceData() {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };

        // if (this.fromDate) {
        //   params.fromDate = this.fromDate;
        //   params.toDate = this.toDate;
        // }
        try {
          if (this.participantsSelected && this.participantsSelected[0] !== "all") {
            params.participantsIds = convertArrToString(this.participantsSelected);
          }
          if (this.specificSiteId && this.specificSiteId.length > 0) {
            params.siteId = this.specificSiteId[0];
          }
          params.groupBy = "participant";
          const data = await this.$api.getCompliance(params);
          if (data.ok) {
            try {
              response = d3.csvParse(data.body);
              response = d3
                .nest()
                .key(d => d.date)
                .sortKeys(d3.ascending)
                .key(d => d.countryName)
                .sortKeys(d3.ascending)
                .key(d => d.siteName)
                .sortKeys(d3.ascending)
                .entries(response);
            } catch (error) {
              return null;
            }
          }

          this.isLoading = false;
        } catch (err) {}
        return response;
      }
    },
    async filter(triggerBy, filterValue) {
      this.filteredRawDataSiteRecruitment = this.siteRecruitmentRawData;
      switch (triggerBy) {
        case "country":
          this.countrySelected = filterValue;
          const payloadQuery = {
            countries: {
              ...this.rawParticipantStatus,
              ...this.formStatusRaw,
              ...this.overallMissingRaw
            },
            countriesByActivities: {
              ...this.queriesRaw,
              ...this.activitiesRaw,
              ...this.overallCollectionMetricRaw
            },
            countriesByD3Nest: [...this.complianceData, ...this.complianceDataByParticipant]
          };

          if (filterValue === "all" || (filterValue.length > 0 && filterValue[0].toLowerCase() === "all")) {
            this.filteredRawDataSiteRecruitment = JSON.parse(JSON.stringify(this.siteRecruitmentRawData)); //deep clone
          } else {
            this.filteredRawDataSiteRecruitment = {};
            filterValue &&
              typeof filterValue === "object" &&
              filterValue.forEach(country => {
                this.filteredRawDataSiteRecruitment[country] = this.siteRecruitmentRawData[country];
              });
          }

          const countrySelected = filterValue === "all" ? this.countryList : filterValue;
          this.allSitesList = utils.getAllSitesWhenFilteringCountry(payloadQuery, countrySelected);
          this.sitesSelected = filterValue === "all" ? ["all"] : this.allSitesList;

          this.callApi(true, triggerBy);
          break;
        case "site":
          this.filteredRawDataSiteRecruitment = {};

          if (filterValue === "all") {
            this.filteredRawDataSiteRecruitment = this.siteRecruitmentRawData;
          } else {
            filterValue &&
              typeof filterValue === "object" &&
              filterValue.forEach(siteName => {
                const countryName = this.mapSiteCountry[siteName];
                if (!this.filteredRawDataSiteRecruitment[countryName]) {
                  this.filteredRawDataSiteRecruitment[countryName] = {};
                }
                if (this.siteRecruitmentRawData[countryName] && this.siteRecruitmentRawData[countryName][siteName]) {
                  this.filteredRawDataSiteRecruitment[countryName][siteName] = this.siteRecruitmentRawData[countryName][siteName];
                }
              });
          }

          this.sitesSelected = filterValue === "all" ? ["all"] : filterValue;

          await this.callApi(true, triggerBy);

          break;
        case "date": {
          this.monthSelected = filterValue;
          this.fromDate = this.fromDate = filterValue[0].value;
          this.toDate = this.toDate = filterValue[1].value;

          await this.callApi(true, triggerBy);

          if (this.sitesSelected && this.sitesSelected[0] !== "all" && this.sitesSelected !== "all") {
            this.filteredRawDataSiteRecruitment = {};
            this.sitesSelected.forEach(siteName => {
              const countryName = this.mapSiteCountry[siteName];
              if (!this.filteredRawDataSiteRecruitment[countryName]) {
                this.filteredRawDataSiteRecruitment[countryName] = {};
              }
              this.filteredRawDataSiteRecruitment[countryName][siteName] = this.siteRecruitmentRawData[countryName][siteName];
            });
          }

          this.loader ? this.loader.hide() : "";
          this.isLoading = false;
          break;
        }
        case "participant": {
          this.participantsSelected = filterValue === "all" ? ["all"] : filterValue.checkedParticipants;
          if (this.participantsSelected && this.participantsSelected.length === 0) {
            this.setToEmptyData();
            return;
          }

          await this.callApi(true, triggerBy);

          // this.loader.hide();
          this.isLoading = false;
          break;
        }
        default:
          break;
      }

      this.filterTriggered = !this.filterTriggered;

      const countrySelected = this.countrySelected === "all" ? this.countryList : this.countrySelected;
      const sitesSelected = this.sitesSelected[0] === "all" ? this.allSitesList : this.sitesSelected;

      this.queriesSeries = dManagement.GET_QUERIES_PERCENTAGE(this.queriesRaw, countrySelected, sitesSelected) || {};
      if (this.siteRecruitmentRawData != null) {
        const isSiteStaff = this.specificSiteId && this.specificSiteId.length > 0;
        this.fpiDataForViz = await EnrollmentService.wrangleSiteRecruitmentData(this.filteredRawDataSiteRecruitment, "fpi", this.fromDate, this.toDate, isSiteStaff);

        // Update summary cards
        const stats = await EnrollmentService.calculateRecruitmentStats(this.filteredRawDataSiteRecruitment, this.fromDate, this.toDate);
        this.fastestFpiDateBegin = this.getDateString(stats.fastestFpi.activeDate);
        this.fastestFpiDateEnd = this.getDateString(stats.fastestFpi.date);
        this.fastestFpiSiteCountry = stats.fastestFpi.site
          ? {
              site: stats.fastestFpi.site,
              country: stats.fastestFpi.country
            }
          : null;
        this.fastestFirstDataDateBegin = this.getDateString(stats.fastestFirstData.activeDate);
        this.fastestFirstDataDateEnd = this.getDateString(stats.fastestFirstData.date);
        this.fastestFirstDataSiteCountry = stats.fastestFirstData.site
          ? {
              site: stats.fastestFirstData.site,
              country: stats.fastestFirstData.country
            }
          : null;

        this.totalFpiSites = stats.totalFpi;
        this.totalFirstDataSites = stats.totalFirstData;
      } else {
        this.fpiDataForViz = null;
        this.totalFpiSites = 0;
        this.fastestFpiSiteCountry = null;
        this.fastestFpiDateBegin = "";
        this.fastestFpiDateEnd = "";
        this.firstDataDataForViz = null;
      }
    },

    async callApi(turnOffGlobalLoader = false, filterBy) {
      let tmpMappingSiteCountry = {};
      let apiPromises = [];
      let newCountries = [];
      let newSites = [];

      if (["mounted", "date"].includes(filterBy)) {
        apiPromises = apiPromises.concat([
          // Call getParticipantStatusEndpoints...
          this.getParticipantStatusEndpoints().then(raws => {
            const countries = utils.getCountries(raws.locations);
            const sites = utils.getSites(raws.locations, countries);

            this.tmpCountries = this.tmpCountries.concat(countries);
            this.tmpSites = this.tmpSites.concat(sites);
            this.rawParticipantStatus = raws.locations;

            tmpMappingSiteCountry = {
              ...tmpMappingSiteCountry,
              ...utils.mappingSiteCountry(this.rawParticipantStatus, "general")
            };
            this.tmpMapSiteCountry = { ...tmpMappingSiteCountry };
            this.dataLoaded.rawParticipantStatus = true;
          }),
          // Call getNewQueries...
          this.getNewQueries().then(raws => {
            const countries = utils.getCountriesByActivities(raws);
            const sites = utils.getSiteByActivities(raws, countries);

            this.tmpCountries = this.tmpCountries.concat(countries);
            this.tmpSites = this.tmpSites.concat(sites);
            this.queriesRaw = raws;

            tmpMappingSiteCountry = {
              ...tmpMappingSiteCountry,
              ...utils.mappingSiteCountry(this.queriesRaw, "activities")
            };
            this.tmpMapSiteCountry = { ...tmpMappingSiteCountry };
            this.dataLoaded.queriesRaw = true;
          }),
          // Call getNewActivities...
          this.getNewActivities().then(raws => {
            const countries = utils.getCountriesByActivities(raws);
            const sites = utils.getSiteByActivities(raws, countries);

            this.tmpCountries = this.tmpCountries.concat(countries);
            this.tmpSites = this.tmpSites.concat(sites);
            this.activitiesRaw = raws;

            tmpMappingSiteCountry = {
              ...tmpMappingSiteCountry,
              ...utils.mappingSiteCountry(this.activitiesRaw, "activities")
            };
            this.tmpMapSiteCountry = { ...tmpMappingSiteCountry };
            this.dataLoaded.activitiesRaw = true;
          }),
          // Call getNewFormStatus...
          this.getNewFormStatus().then(raws => {
            const countries = utils.getCountries(raws);
            const sites = utils.getSites(raws, countries);

            this.tmpCountries = this.tmpCountries.concat(countries);
            this.tmpSites = this.tmpSites.concat(sites);
            this.formStatusRaw = raws;

            tmpMappingSiteCountry = {
              ...tmpMappingSiteCountry,
              ...utils.mappingSiteCountry(this.formStatusRaw, "general")
            };
            this.tmpMapSiteCountry = { ...tmpMappingSiteCountry };
            this.dataLoaded.formStatusRaw = true;
          }),
          // getOverallMissingData...
          this.getOverallMissingData().then(raws => {
            if (raws) {
              const countries = utils.getCountries(raws);
              const sites = utils.getSites(raws, countries);

              this.tmpCountries = this.tmpCountries.concat(countries);
              this.tmpSites = this.tmpSites.concat(sites);
              this.overallMissingRaw = raws;

              tmpMappingSiteCountry = {
                ...tmpMappingSiteCountry,
                ...utils.mappingSiteCountry(this.overallMissingRaw, "general")
              };
              this.tmpMapSiteCountry = { ...tmpMappingSiteCountry };
              this.dataLoaded.overallMissingRaw = true;
            }
          }),
          this.getRecruitmentVisualizationRawData("fpi").then(async raws => {
            this.siteRecruitmentRawData = raws;
            if (this.siteRecruitmentRawData != null) {
              const isSiteStaff = this.specificSiteId && this.specificSiteId.length > 0;
              this.fpiDataForViz = await EnrollmentService.wrangleSiteRecruitmentData(this.siteRecruitmentRawData, "fpi", this.fromDate, this.toDate, isSiteStaff);

              // Update summary cards
              const stats = await EnrollmentService.calculateRecruitmentStats(this.siteRecruitmentRawData, this.fromDate, this.toDate);
              this.fastestFpiDateBegin = this.getDateString(stats.fastestFpi.activeDate);
              this.fastestFpiDateEnd = this.getDateString(stats.fastestFpi.date);
              this.fastestFpiSiteCountry = stats.fastestFpi.site
                ? {
                    site: stats.fastestFpi.site,
                    country: stats.fastestFpi.country
                  }
                : null;

              this.totalFpiSites = stats.totalFpi;
            } else {
              this.fpiDataForViz = null;
            }
          })
        ]);
      }

      if (["mounted"].includes(filterBy)) {
        apiPromises = apiPromises.concat([
          this.getComplianceData().then(raws => {
            if (raws) {
              const countries = utils.getCountriesFromD3NestResult(raws);
              const sites = utils.getSitesFromD3NestResult(raws, countries);

              this.tmpCountries = this.tmpCountries.concat(countries);
              this.tmpSites = this.tmpSites.concat(sites);
              this.complianceData = raws;
              this.completionData = raws;

              tmpMappingSiteCountry = {
                ...tmpMappingSiteCountry,
                ...utils.mappingSiteCountry(raws, "d3")
              };
              this.tmpMapSiteCountry = { ...tmpMappingSiteCountry };
              this.dataLoaded.complianceData = true;
              this.dataLoaded.completionData = true;
            }
          }),
          this.getParticipantComplianceData().then(raws => {
            if (raws) {
              const countries = utils.getCountriesFromD3NestResult(raws);
              const sites = utils.getSitesFromD3NestResult(raws, countries);

              this.tmpCountries = this.tmpCountries.concat(countries);
              this.tmpSites = this.tmpSites.concat(sites);
              this.complianceDataByParticipant = raws;
              this.completionDataByParticipant = raws;

              tmpMappingSiteCountry = {
                ...tmpMappingSiteCountry,
                ...utils.mappingSiteCountry(raws, "d3")
              };
              this.tmpMapSiteCountry = { ...tmpMappingSiteCountry };
            }
          })
        ]);
      }

      if (["participant"].includes(filterBy)) {
        apiPromises = apiPromises.concat([
          // Call getParticipantStatusEndpoints...
          this.getParticipantStatusEndpoints().then(raws => {
            const countries = utils.getCountries(raws.locations);
            const sites = utils.getSites(raws.locations, countries);

            newCountries = newCountries.concat(countries);
            newSites = newSites.concat(sites);
            this.rawParticipantStatus = raws.locations;

            tmpMappingSiteCountry = {
              ...tmpMappingSiteCountry,
              ...utils.mappingSiteCountry(this.rawParticipantStatus, "general")
            };
            this.tmpMapSiteCountry = { ...tmpMappingSiteCountry };
            this.dataLoaded.rawParticipantStatus = true;
          }),
          // Call getNewQueries...
          this.getNewQueries().then(raws => {
            const countries = utils.getCountriesByActivities(raws);
            const sites = utils.getSiteByActivities(raws, countries);

            newCountries = newCountries.concat(countries);
            newSites = newSites.concat(sites);
            this.queriesRaw = raws;

            tmpMappingSiteCountry = {
              ...tmpMappingSiteCountry,
              ...utils.mappingSiteCountry(this.queriesRaw, "activities")
            };
            this.tmpMapSiteCountry = { ...tmpMappingSiteCountry };
            this.dataLoaded.queriesRaw = true;
          }),
          // Call getNewActivities...
          this.getNewActivities().then(raws => {
            const countries = utils.getCountriesByActivities(raws);
            const sites = utils.getSiteByActivities(raws, countries);

            newCountries = newCountries.concat(countries);
            newSites = newSites.concat(sites);
            this.activitiesRaw = raws;

            tmpMappingSiteCountry = {
              ...tmpMappingSiteCountry,
              ...utils.mappingSiteCountry(this.activitiesRaw, "activities")
            };
            this.tmpMapSiteCountry = { ...tmpMappingSiteCountry };
            this.dataLoaded.activitiesRaw = true;
          }),
          // Call getNewFormStatus...
          this.getNewFormStatus().then(raws => {
            const countries = utils.getCountries(raws);
            const sites = utils.getSites(raws, countries);

            newCountries = newCountries.concat(countries);
            newSites = newSites.concat(sites);
            this.formStatusRaw = raws;

            tmpMappingSiteCountry = {
              ...tmpMappingSiteCountry,
              ...utils.mappingSiteCountry(this.formStatusRaw, "general")
            };
            this.tmpMapSiteCountry = { ...tmpMappingSiteCountry };
            this.dataLoaded.formStatusRaw = true;
          }),
          // getOverallMissingData...
          this.getOverallMissingData().then(raws => {
            if (raws) {
              const countries = utils.getCountries(raws);
              const sites = utils.getSites(raws, countries);

              newCountries = newCountries.concat(countries);
              newSites = newSites.concat(sites);
              this.overallMissingRaw = raws;

              tmpMappingSiteCountry = {
                ...tmpMappingSiteCountry,
                ...utils.mappingSiteCountry(this.overallMissingRaw, "general")
              };
              this.tmpMapSiteCountry = { ...tmpMappingSiteCountry };
              this.dataLoaded.overallMissingRaw = true;
            }
          }),
          this.getRecruitmentVisualizationRawData("fpi").then(async raws => {
            this.siteRecruitmentRawData = raws;
            if (this.siteRecruitmentRawData != null) {
              const isSiteStaff = this.specificSiteId && this.specificSiteId.length > 0;
              this.fpiDataForViz = await EnrollmentService.wrangleSiteRecruitmentData(this.siteRecruitmentRawData, "fpi", this.fromDate, this.toDate, isSiteStaff);

              // Update summary cards
              const stats = await EnrollmentService.calculateRecruitmentStats(this.siteRecruitmentRawData, this.fromDate, this.toDate);
              this.fastestFpiDateBegin = this.getDateString(stats.fastestFpi.activeDate);
              this.fastestFpiDateEnd = this.getDateString(stats.fastestFpi.date);
              this.fastestFpiSiteCountry = stats.fastestFpi.site
                ? {
                    site: stats.fastestFpi.site,
                    country: stats.fastestFpi.country
                  }
                : null;

              this.totalFpiSites = stats.totalFpi;
            } else {
              this.fpiDataForViz = null;
            }
          }),
          this.getComplianceData().then(raws => {
            if (raws) {
              const countries = utils.getCountriesFromD3NestResult(raws);
              const sites = utils.getSitesFromD3NestResult(raws, countries);

              newCountries = newCountries.concat(countries);
              newSites = newSites.concat(sites);
              this.complianceData = raws;
              this.completionData = raws;

              tmpMappingSiteCountry = {
                ...tmpMappingSiteCountry,
                ...utils.mappingSiteCountry(raws, "d3")
              };
              this.tmpMapSiteCountry = { ...tmpMappingSiteCountry };
              this.dataLoaded.complianceData = true;
              this.dataLoaded.completionData = true;
            }
          }),
          this.getParticipantComplianceData().then(raws => {
            if (raws) {
              const countries = utils.getCountriesFromD3NestResult(raws);
              const sites = utils.getSitesFromD3NestResult(raws, countries);

              newCountries = newCountries.concat(countries);
              newSites = newSites.concat(sites);
              this.complianceDataByParticipant = raws;
              this.completionDataByParticipant = raws;

              tmpMappingSiteCountry = {
                ...tmpMappingSiteCountry,
                ...utils.mappingSiteCountry(raws, "d3")
              };
              this.tmpMapSiteCountry = { ...tmpMappingSiteCountry };
            }
          })
        ]);
      }
      await Promise.all(apiPromises);
      if (["participant"].includes(filterBy)) {
        this.tmpCountries = newCountries;
        this.tmpSites = newSites;
      }
      this.callApiCompleted = true;
      if (turnOffGlobalLoader) {
        await this.turnOffGlobalLoader();
      }
    },

    async turnOffGlobalLoader() {
      const query = Object.assign({}, this.$route.query);
      delete query.automatic_off_loader;
      this.$router.replace({ query });
      this.$store.commit("SHOW_LOADER", false);
    }
  },

  async mounted() {
    this.$router.push({ query: { automatic_off_loader: false } });
    this.studyId = this.$route.params.studyId;
    await this.prepareDatePicker();

    this.specificSiteId = _get(this.user, "siteIds", []);

    const tabList = [
      { name: ACTIVITIES, visible: "12" },
      { name: COUNTRIES, visible }
    ];
    if (this.specificSiteId && this.specificSiteId.length === 0) {
      tabList.push({ name: SITES, visible });
      this.tabListOverallQueryStatus.push(SITES);
      this.tabListActCountSit.push(SITES);
    }
    tabList.push({ name: PARTICIPANTS, visible });
    this.tabList = tabList;
    await this.callApi(true, "mounted");
    await this.turnOffGlobalLoader();
  },

  computed: {
    ...mapGetters(["user"]),
    isMapsApiAvailable() {
      const notAvailableDomains = [".cn"];
      const hostname = window.location.hostname;
      if (hostname.lastIndexOf(".") == -1) {
        return true;
      }
      const domainEnding = hostname.substring(hostname.lastIndexOf("."));
      return !(notAvailableDomains.indexOf(domainEnding) > -1);
    }
  },

  watch: {
    queriesRaw: function(newValue) {
      const countrySelected = this.countrySelected === "all" ? this.countryList : this.countrySelected;
      const sitesSelected = this.sitesSelected[0] === "all" ? this.allSitesList : this.sitesSelected;

      this.queriesRaw = newValue;
      this.queriesSeries = dManagement.GET_QUERIES_PERCENTAGE(newValue, countrySelected, sitesSelected) || {};
    },
    overallMissingRaw: function(newValue) {
      this.overallMissingRaw = newValue;
    },
    formStatusRaw: function(newValue) {
      this.formStatusRaw = newValue;
    },
    fpiDataForViz: function(newValue) {
      this.fpiDataForViz = newValue;
      this.dataLoaded.fpiDataForViz = true;
    },
    activitiesRaw: function(newValue) {
      this.activitiesRaw = newValue;
    },
    tmpCountries: function(newVal) {
      const allCountries = _.uniq(newVal);
      this.countryList = _.orderBy(Array.from(allCountries), [country => country.toLowerCase()]);
    },

    tmpSites: function(val) {
      const allSites = _.uniq(val);
      this.allSitesList = _.orderBy(Array.from(allSites), [site => site.toLowerCase()]);
    },
    tmpMapSiteCountry: function(val) {
      this.mapSiteCountry = { ...val };
    }
  }
};
</script>

<style scoped>
.height-90 {
  min-height: 90px;
}

.form-status {
  height: 95% !important;
}

.overall-query-status {
  height: 95% !important;
}
</style>
